document.addEventListener('DOMContentLoaded', function (){
    const OPTIONS = {dragFree: true, containScroll: 'trimSnaps'}

    const emblaNode = document.querySelector('.cpf-section')
    const viewportNode = emblaNode.querySelector('.cpf-viewport')
    const prevBtnNode = emblaNode.querySelector('.cpf-btn-prev')
    const nextBtnNode = emblaNode.querySelector('.cpf-btn-next')

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS);
    const removePrevNextBtnsClickHandlers = ccfFn.addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtnNode,
        nextBtnNode
    )
    emblaApi.on('destroy', removePrevNextBtnsClickHandlers);

    document.querySelectorAll('.cpf-collection-item').forEach(function (el){
        el.addEventListener('click', function (evt){
            const btnClicked = evt.target.closest('.cpf-collection-item');
            const optionBox = btnClicked.closest('.cpf-section').querySelector('.cpf-option-box');
            if(btnClicked.classList.contains('cpf-selected')){
                ccfFn.hideOptionBox(optionBox);
                btnClicked.classList.remove('cpf-selected');
            }
            else{
                btnClicked.closest('.cpf-collection-list').querySelectorAll('.cpf-collection-item.cpf-selected').forEach(function (el){
                    el.classList.remove('cpf-selected');
                });
                btnClicked.classList.add('cpf-selected');
                const inputSelect = btnClicked.closest('.cpf-section').querySelector('.cpf-input-select');
                inputSelect.value = '';
                inputSelect.setAttribute('data-item', btnClicked.closest('.cpf-slide-item').getAttribute('data-index'));
                const jsonData = JSON.parse(btnClicked.closest('.cpf-slide-item').querySelector('.cpf-sub-data-json').textContent);
                ccfFn.showOptionBox(optionBox, jsonData);
            }
        });
    });

    let cpfTimeoutQuery = 0;
    document.querySelectorAll('.cpf-input-select').forEach(function (el){
        el.addEventListener('input', function (evt){
            if(cpfTimeoutQuery)
                clearTimeout(cpfTimeoutQuery);
            const optionBox = evt.target.closest('.cpf-section').querySelector('.cpf-option-box');
            const dataIndex = evt.target.getAttribute('data-item');
            let jsonData = [];
            if(dataIndex)
                jsonData = JSON.parse(evt.target.closest('.cpf-section').querySelector('.cpf-slide-item[data-index="'+dataIndex+'"] .cpf-sub-data-json').textContent);
            else {
                evt.target.closest('.cpf-section').querySelectorAll('.cpf-sub-data-json').forEach(function (jsonItem){
                    jsonData = jsonData.concat(JSON.parse(jsonItem.textContent));
                });
            }

            cpfTimeoutQuery = setTimeout(function (){
                ccfFn.showOptionBox(optionBox, jsonData, evt.target.value);
            }, 400);
        });
        el.addEventListener('focus', function (evt){
            evt.target.dispatchEvent(new Event('input', { bubbles: true }));
        });
    });

    document.querySelectorAll('.cpf-arrow-select').forEach( function (el){
        el.addEventListener('click', function (evt){
            evt.target.closest('.cpf-input-wrapper').querySelector('.cpf-input-select').focus();
        })
    });

    document.querySelectorAll('.cpf-btn-open, .cpf-btn-close').forEach(function (el){
        el.addEventListener('click', function (evt){
            evt.target.closest('.cpf-section').querySelector('.cpf-filter-box.hidden').classList.remove('hidden');
            evt.target.closest('.cpf-filter-box').classList.add('hidden');
        });
    });

    document.addEventListener('click', function (evt){
        if(!evt.target.closest('.cpf-select-box') && !evt.target.closest('.cpf-collection-item')){
            document.querySelectorAll('.cpf-section .cpf-option-box:not(.hidden)').forEach(function (el){
                ccfFn.hideOptionBox(el);
            });
        }
    });

});
var ccfFn = {
    addTogglePrevNextBtnsActive: function(emblaApi, prevBtn, nextBtn){
        const togglePrevNextBtnsState = () => {
            if (emblaApi.canScrollPrev())  prevBtn.parentNode.classList.remove('hidden');
            else  prevBtn.parentNode.classList.add('hidden');

            if (emblaApi.canScrollNext()) nextBtn.parentNode.classList.remove('hidden')
            else nextBtn.parentNode.classList.add('hidden')
        }

        emblaApi
            .on('select', togglePrevNextBtnsState)
            .on('init', togglePrevNextBtnsState)
            .on('reInit', togglePrevNextBtnsState)

        return () => {
            prevBtn.removeAttribute('disabled')
            nextBtn.removeAttribute('disabled')
        }
    },
    addPrevNextBtnsClickHandlers: function(emblaApi, prevBtn, nextBtn){
        const scrollPrev = () => {
            emblaApi.scrollPrev()
        }
        const scrollNext = () => {
            emblaApi.scrollNext()
        }
        prevBtn.addEventListener('click', scrollPrev, false)
        nextBtn.addEventListener('click', scrollNext, false)

        const removeTogglePrevNextBtnsActive = this.addTogglePrevNextBtnsActive(
            emblaApi,
            prevBtn,
            nextBtn
        )

        return () => {
            removeTogglePrevNextBtnsActive()
            prevBtn.removeEventListener('click', scrollPrev, false)
            nextBtn.removeEventListener('click', scrollNext, false)
        }
    },
    showOptionBox: function (optionBox, jsonData, query){
        let listHtml = '';
        if(jsonData && jsonData.length){
            let listOptions = [];
            if(query) query = query.trim();
            if(query) {
                query = query.trim().split(/\s+/);
                jsonData.forEach(function (item){
                    for (let i = 0; i < query.length; i++) {
                        if(item.title.toLowerCase().includes(query[i].toLowerCase())){
                            listOptions.push({title: ccfFn.formatTitleSearch(item.title, query), url: item.url});
                        }
                    }
                });
            }
            else{
                listOptions = jsonData;
            }
            listHtml += `<ul class="block max-h-[500px] overflow-x-hidden overflow-y-auto">`;
            if(listOptions.length){
                listOptions.forEach(function (item){
                    listHtml += `<li class="border-b border-gray-200 last:border-b-none"><a href="${item.url}" class="block w-full px-6 py-3 rounded-xl cursor-pointer hover:font-bold">${item.title}</a></li>`;
                });
            }
            else{
                listHtml += `<li><a href="${optionBox.getAttribute('data-fd-url')}" class="block w-full px-6 py-3 rounded-xl cursor-pointer hover:font-bold">${optionBox.getAttribute('data-fd-title')}</a></li>`;
            }
            listHtml += `</ul>`;
        }
        optionBox.innerHTML = listHtml;
        optionBox.classList.remove('hidden');
        optionBox.closest('.cpf-select-box').classList.add('cpf-active');
    },
    hideOptionBox: function (optionBox){
        optionBox.classList.add('hidden');
        optionBox.closest('.cpf-section').querySelector('.cpf-input-select').setAttribute('data-item', '');
        optionBox.closest('.cpf-select-box').classList.remove('cpf-active');
    },
    formatTitleSearch: function (title, query){
        const regex = new RegExp(
            query.map(function(q) {
                return q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }).join("|"),
            "gi"
        );

        return title.replace(regex, function(match) {
            return "<strong>" + match + "</strong>";
        });

    }
}
